import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fa from 'vuetify/es5/locale/fa';
import en from 'vuetify/es5/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
    rtl: true,
    lang: {
        locales: {fa, en},
        current: 'fa',
    }
});
